<template>
  <div class="editor-modal" id="dynamic-form-modal">
    <h3>{{ title }}</h3>
    <form @submit.stop.prevent="_onSubmit">
      <DynamicForm
        class="dynamic-form"
        :formData="formData"
        :source="source"
        :formDataIndex="0"
        @changes="changesMade"
        @submit-event="_onSubmit"
        @invalid-fields="checkFields"
        :ignoreInvalid="ignoreInvalid"
      />
      <p v-if="!valid" class="text-small text-danger">
        {{ invalidText || $t('dynamic-form.invalid-default-message')}}
      </p>
      <p v-if="danger" class="text-small text-danger">
        {{ danger }}
      </p>
      <div class="actions">
        <button type="submit" class="btn btn-primary" :disabled="!valid">{{ primaryButton }}</button>
        <button type="button" class="btn btn-secondary" @click="$emit('close')">{{ $t("cancel") }}</button>
      </div>
    </form>
  </div>
</template>
<script>
import DynamicForm from "@/components/DynamicForm";
export default {
  components: {
    DynamicForm
  },
  props: {
    title: String,
    formData: Array,
    primaryButton: String,
    source: Object,
    onSubmit: Function,
    onChange: Function,
    aiDangerText: String,
    invalidText: String,
    ignoreInvalid: Array
  },
  data() {
    return {
      inputValid: true,
      formValid: true
    };
  },
  methods: {
    validate(value) {
      this.inputValid = value;
    },
    changesMade() {
      this.onChange(this.source, this.validate);
    },
    _onSubmit() {
      this.onSubmit(this.source);
      this.$emit("close");
    },
    checkFields(validityStatus) {
      this.formValid = !validityStatus.invalidForm; 
    }
  },
  computed: {
    danger() {
      if (this.aiDangerText && this.source.sectionType == "ai") {
        return this.aiDangerText;
      } else return null;
    },
    valid() {
      return this.inputValid && this.formValid;
    }
  }
};
</script>

<style lang="less">
#dynamic-form-modal {
  padding: 16px;
  h3 {
    margin: 0;
  }
  p {
    margin-top: 12px;
  }
  .actions {
    margin-top: 12px;
    display: flex;
    flex-direction: row;
    gap: 12px;
  }
}
</style>
